import { and, count, eq, type PowerSyncDrizzleDB, tx, wallet } from "@cashsync/powersync";
import { liveTxFilters, liveWalletFilters } from "./filters";

/**
 * LIVE entity counters from local SQLite, for `checkUnsyncedActor`
 * (prompt "keep local data?" when migrating from guest to real account).
 * Previously they ran RAW `count() from(tx|wallet)` in `auth/controllers.ts`,
 * also counting rows in trash (scattered invariant bug: a deleted tx or
 * wallet triggered the "you have local data" prompt). Via the live layer
 * they only count live rows. The guest→real merge still runs in
 * `sweepVisitorData`, so no row is lost; these counters only
 * decide whether the prompt is SHOWN.
 */
export function getLiveTxCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(tx)
    .where(and(eq(tx.user_id, userId), ...liveTxFilters()));
}

export function getLiveWalletCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(wallet)
    .where(and(eq(wallet.user_id, userId), ...liveWalletFilters()));
}
